/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { LocalStorageState, writeToLocalStorageUserInfo } from '../reducers/userReducer';
import { i18n } from '../translation/i18n';
import moment from 'moment';
import apiClient from '../api/apiClient';
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import { UserActionType } from '../actions/userActions';

let prevValue: LocalStorageState = null;

const LcStorageMiddleware =
    ({ getState }: MiddlewareAPI) =>
    (next: Dispatch) =>
    (action: AnyAction) => {
        const result = next(action);
        const nextState = getState();

        const nextValue: LocalStorageState = {
            localeId: nextState.userReducer.localeId,
            authData: nextState.userReducer.authData,
        };

        let isNeedToUpdateLocalStorage: boolean = false;

        if (nextValue.localeId !== i18n.language) {
            apiClient.setLocaleHeader(nextValue.localeId);
            i18n.changeLanguage(nextValue.localeId);
            moment.locale(nextValue.localeId);
            isNeedToUpdateLocalStorage = true;
        }

        if (UserActionType.CHANGE_LOCALE === action.type) {
            apiClient.setLocaleHeader(nextValue.localeId);
            i18n.changeLanguage(nextValue.localeId);
            moment.locale(nextValue.localeId);
            isNeedToUpdateLocalStorage = true;
        }

        if (!prevValue || nextValue.authData !== prevValue.authData) {
            isNeedToUpdateLocalStorage = true;
        }

        if (isNeedToUpdateLocalStorage) {
            writeToLocalStorageUserInfo(nextValue);
        }

        prevValue = nextValue;

        return result;
    };

export default LcStorageMiddleware;
